<template>
  <div>
    <div id="subnav" class="form-inline">
      <div class="form-group">
        <div class="input-group">
          <input id="search-string-input" v-on:keydown.enter="changeURL" v-model="searchString" v-on:input="triggerSuggestions()" type="search" class="form-control form-filter-search" placeholder="Enter a city, zip, or address">
          <div class="input-group-append form-filter-search-button" v-on:click="changeURL">
            <div class="input-group-text"><i class="fas fa-search"></i></div>
          </div>
        </div>
      </div>
      <propertyType></propertyType>
      <beds></beds>
      <baths></baths>
      <!--<sqft></sqft>-->
      <price></price>
      <more></more>
      <update v-on:update="changeURL"></update>
    </div>
    <house-suggestion-dropdown ref="suggestionDropdown" v-on:suggestionSearch="performSuggestionSearch"></house-suggestion-dropdown>
  </div>
</template>

<script>
import router from '../../../../router/index.js'
import elasticsearch from 'elasticsearch'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AWSConnector from 'http-aws-es'
import AWS from 'aws-sdk/global'
import baths from './buttons/Baths.vue'
import beds from './buttons/Beds.vue'
import more from './buttons/More.vue'
import price from './buttons/Price.vue'
import propertyType from './buttons/PropertyType.vue'
import sqft from './buttons/Sqft.vue'
import update from './buttons/Update.vue'
import HouseSuggestionDropdown from './HouseSuggestionDropdown.vue'

export default {
  components: {
    baths,
    beds,
    more,
    price,
    propertyType,
    sqft,
    update,
    HouseSuggestionDropdown
  },
  data () {
    return {
      searchString: '',
      suggestion: null
    }
  },
  mounted () {
    this.getDataFromURL()
    this.performSearch()
  },
  computed: {
    ...mapGetters([
      'getSecretAccessKey',
      'getAccessKeyId',
      'getSessionToken'
    ]),
    ...mapGetters('homeSearch', [
      'getPropertyType',
      'getBedNumber',
      'getBathNumber',
      'getListingStatus',
      'getListingOptions',
      'getListingEvents',
      'getMinSqft',
      'getMaxSqft',
      'getMinPrice',
      'getMaxPrice',
      'getStories',
      'getInsideFeatures',
      'getOutsideFeatures',
      'getHeatingCooling',
      'getParking',
      'getMaxHomeAge',
      'getMinHomeAge',
      'getGarage',
      'getLotView',
      'getCommunityAmenities',
      'getMinHOA',
      'getMaxHOA'
    ])
  },
  methods: {
    ...mapActions([
      'unauthenticatedLogin'
    ]),
    ...mapMutations('homeSearch', [
      'updatePropertyType',
      'updateBedNumber',
      'updateBathNumber',
      'updateListingStatus',
      'updateListingOptions',
      'updateListingEvents',
      'updateMinSqft',
      'updateMaxSqft',
      'updateMinPrice',
      'updateMaxPrice',
      'updateStories',
      'updateInsideFeatures',
      'updateOutsideFeatures',
      'updateHeatingCooling',
      'updateParking',
      'updateMaxHomeAge',
      'updateMinHomeAge',
      'updateGarage',
      'updateLotView',
      'updateCommunityAmenities',
      'updateMinHOA',
      'updateMaxHOA',
      'updateLastNonEmptyQuery'
    ]),
    async authenticate () {
      try {
        await this.unauthenticatedLogin()
      } catch (error) {
        console.log(error)
      }
    },
    getDataFromURL () {
      if (this.$route.query.search) this.searchString = this.$route.query.search
      if (this.$route.query.propertytype) this.updatePropertyType(this.$route.query.propertytype)
      this.$route.query.beds && ['1', '2', '3', '4', '5'].includes(this.$route.query.beds) ? this.updateBedNumber(this.$route.query.beds) : this.updateBedNumber('Any')
      this.$route.query.baths && ['1', '2', '3', '4', '5'].includes(this.$route.query.baths) ? this.updateBathNumber(this.$route.query.baths) : this.updateBathNumber('Any')
      if (this.$route.query.listingstatus) this.updateListingStatus(this.$route.query.listingstatus)
      if (this.$route.query.listingoptions) this.updateListingOptions(this.$route.query.listingoptions)
      if (this.$route.query.listingevents) this.updateListingEvents(this.$route.query.listingevents)
      if (this.$route.query.minsqft) this.updateMinSqft(this.$route.query.minsqft)
      if (this.$route.query.maxsqft) this.updateMaxSqft(this.$route.query.maxsqft)
      if (this.$route.query.minprice) this.updateMinPrice(this.$route.query.minprice)
      if (this.$route.query.maxprice) this.updateMaxPrice(this.$route.query.maxprice)
      if (this.$route.query.stories) this.updateStories(this.$route.query.stories)
      if (this.$route.query.insidefeatures) this.updateInsideFeatures(this.$route.query.insidefeatures)
      if (this.$route.query.outsidefeatures) this.updateOutsideFeatures(this.$route.query.outsidefeatures)
      if (this.$route.query.hc) this.updateHeatingCooling(this.$route.query.hc)
      if (this.$route.query.parking) this.updateParking(this.$route.query.parking)
      if (this.$route.query.maxhomeage) this.updateMaxHomeAge(this.$route.query.maxhomeage)
      if (this.$route.query.minhomeage) this.updateMinHomeAge(this.$route.query.minhomeage)
      if (this.$route.query.garage) this.updateGarage(this.$route.query.garage)
      if (this.$route.query.lotview) this.updateLotView(this.$route.query.lotview)
      if (this.$route.query.communityamenities) this.updateCommunityAmenities(this.$route.query.communityamenities)
      if (this.$route.query.minhoa) this.updateMinHOA(this.$route.query.minhoa)
      if (this.$route.query.suggestion) this.suggestion = JSON.parse(this.$route.query.suggestion)
    },
    async changeURL () {
      if (this.getSessionToken) {
        router.push({
          path: '/propertysearch',
          query: {
            search: this.searchString,
            suggestion: JSON.stringify(this.suggestion),
            propertyType: this.getPropertyType,
            baths: this.getBathNumber,
            beds: this.getBedNumber,
            listingstatus: this.getListingStatus,
            listingoptions: this.getListingOptions,
            listingevents: this.getListingEvents,
            minsqft: this.getMinSqft,
            maxsqft: this.getMaxSqft,
            minprice: this.getMinPrice,
            maxprice: this.getMaxPrice,
            stories: this.getStories,
            insidefeatures: this.getInsideFeatures,
            outsidefeatures: this.getOutsideFeatures,
            hc: this.getHeatingCooling,
            parking: this.getParking,
            maxhomeage: this.getMaxHomeAge,
            minhomeage: this.getMinHomeAge,
            garage: this.getGarage,
            lotview: this.getLotView,
            communityamenities: this.getCommunityAmenities,
            minhoa: this.getMinHOA,
            maxhoa: this.getMaxHOA
          }
        }).catch((error) => {
          if (error.name !== 'NavigationDuplicated') {
            console.log(error)
          }
        })
      }
    },
    buildFilter () {
      var filter = []

      // Property Types
      if (this.getPropertyType) {
        let propertyTypeShouldClause = []

        if (this.getPropertyType.includes('House')) {
          propertyTypeShouldClause.push({match_phrase: {style: 'Single Family Residence'}})
        }
        if (this.getPropertyType.includes('Townhouse')) {
          propertyTypeShouldClause.push({match_phrase: {style: 'Townhouse'}})
        }
        if (this.getPropertyType.includes('Condo')) {
          propertyTypeShouldClause.push({match_phrase: {style: 'Duplex'}})
          propertyTypeShouldClause.push({match_phrase: {style: 'Two Unit'}})
          propertyTypeShouldClause.push({match_phrase: {style: 'Converted Mansion'}})
          propertyTypeShouldClause.push({match_phrase: {style: 'Apartment'}})
        }
        if (this.getPropertyType.includes('Multi-Family')) {
          propertyTypeShouldClause.push({match_phrase: {style: 'High Rise'}})
          propertyTypeShouldClause.push({match_phrase: {style: 'Low Rise'}})
          propertyTypeShouldClause.push({match_phrase: {style: 'Manor/Village'}})
          propertyTypeShouldClause.push({match_phrase: {style: 'Other'}})
        }
        if (this.getPropertyType.includes('Land')) {
          propertyTypeShouldClause.push({match_phrase: {style: 'Land'}})
        }

        let propertyTypeClause = {
          bool: {
            should: propertyTypeShouldClause
          }
        }
        filter.push(propertyTypeClause)
      }

      // Bedroom Count
      if (['1', '2', '3', '4', '5'].includes(this.getBedNumber)) {
        filter.push({range: {bedroom_count: {gte: this.getBedNumber}}})
      }

      // Bathroom Count
      if (['1', '2', '3', '4', '5'].includes(this.getBathNumber)) {
        filter.push({range: {bathroom_count: {gte: this.getBathNumber}}})
      }

      // Price
      if (this.getMinPrice > 0 && this.getMaxPrice > 0) {
        filter.push({range: {price: {gte: this.getMinPrice, lte: this.getMaxPrice}}})
      } else if (this.getMinPrice > 0 && this.getMaxPrice <= 0) {
        filter.push({range: {price: {gte: this.getMinPrice}}})
      } else if (this.getMinPrice <= 0 && this.getMaxPrice > 0) {
        filter.push({range: {price: {lte: this.getMaxPrice}}})
      }

      // Listing Status
      if (this.getListingStatus.length && !this.getListingStatus.includes('Rental')) {
        filter.push({terms: {'status.keyword': this.getListingStatus}})
        filter.push({
          bool: {
            must_not: {
              term: {special_circumstances: 'rental'}
            }
          }
        })
      } else if (this.getListingStatus.includes('Rental') && this.getListingStatus.length === 1) {
        filter.push({term: {special_circumstances: 'rental'}})
      } else if (this.getListingStatus.length && this.getListingStatus.includes('Rental')) {
        filter.push({
          bool: {
            should: [
              {terms: {'status.keyword': this.getListingStatus}},
              {term: {special_circumstances: 'rental'}}
            ]
          }
        })
      }

      // Listing Options
      if (this.getListingOptions.includes('new construction')) {
        filter.push({match_phrase: {special_circumstances: 'New Construction'}})
      }
      if (this.getListingOptions.includes('foreclosure')) {
        filter.push({term: {special_circumstances: 'foreclosur'}})
      }

      // Listing Events
      if (this.getListingEvents.includes('open houses')) {
        filter.push({exists: {field: 'open_houses'}})
      }
      // TODO: Update mapping to nested and update query to be nested
      if (this.getListingEvents.includes('price reduced')) {
        filter.push({match_phrase: {'price_history.description': 'Price Reduction'}})
      }

      // Square Footage
      if (this.getMinSqft && this.getMaxSqft) {
        filter.push({range: {house_sqft: {gte: this.getMinSqft, lte: this.getMaxSqft}}})
      } else if (this.getMinSqft && !this.getMaxSqft) {
        filter.push({range: {house_sqft: {gte: this.getMinSqft}}})
      } else if (!this.getMinSqft && this.getMaxSqft) {
        filter.push({range: {house_sqft: {lte: this.getMaxSqft}}})
      }

      // Stories
      if (this.getStories === 'Single') {
        filter.push({match_phrase: {stories: '1 Story'}})
      } else if (this.getStories === 'Multi') {
        filter.push({terms: {stories: ['1.5', '2', 'Split']}})
      }

      // Lot Size
      let minLotSizeRelevantField = null
      let minLotSizeValue = null
      if (this.getMinLotSize) {
        minLotSizeValue = parseInt(this.getMinLotSize.match(/\d+/g).join(''))
      }
      if (this.getMinLotSize && this.getMinLotSize.includes('ft')) {
        minLotSizeRelevantField = 'lot_sqft'
      }
      if (this.getMinLotSize && this.getMinLotSize.includes('acre')) {
        minLotSizeRelevantField = 'lot_acres'
      }

      let maxLotSizeRelevantField = null
      let maxLotSizeValue = null
      if (this.getMaxLotSize) {
        maxLotSizeValue = parseInt(this.getMaxLotSize.match(/\d+/g).join(''))
      }
      if (this.getMaxLotSize && this.getMaxLotSize.includes('ft')) {
        maxLotSizeRelevantField = 'lot_sqft'
      }
      if (this.getMaxLotSize && this.getMaxLotSize.includes('acre')) {
        maxLotSizeRelevantField = 'lot_acres'
      }

      let compoundLotSizeComparison = minLotSizeRelevantField && minLotSizeRelevantField === maxLotSizeRelevantField
      if (compoundLotSizeComparison) {
        filter.push({range: {minLotSizeRelevantField: {gte: minLotSizeValue, lte: maxLotSizeValue}}})
      }
      if (!compoundLotSizeComparison && minLotSizeRelevantField) {
        filter.push({range: {minLotSizeRelevantField: {gte: minLotSizeValue}}})
      }
      if (!compoundLotSizeComparison && maxLotSizeRelevantField) {
        filter.push({range: {maxLotSizeComparison: {lte: maxLotSizeValue}}})
      }

      // Inside Features
      if (this.getInsideFeatures.includes('hardwood floors')) {
        filter.push({match_phrase: {unit_amenities: 'Hardwood Floors'}})
      }
      if (this.getInsideFeatures.includes('fireplace')) {
        filter.push({range: {fireplace_count: {gte: 1}}})
      }
      if (this.getInsideFeatures.includes('disability features')) {
        filter.push({exists: {field: 'handicap_access'}})
      }
      if (this.getInsideFeatures.includes('basement')) {
        filter.push({exists: {field: 'basement'}})
      }
      if (this.getInsideFeatures.includes('dining room')) {
        filter.push({exists: {field: 'dining_room'}})
      }
      if (this.getInsideFeatures.includes('office')) {
        filter.push({term: {other_rooms: 'office'}})
      }

      // Outside Features
      if (this.getOutsideFeatures.includes('fenced yard')) {
        filter.push({exists: {field: 'fence'}})
      }
      if (this.getOutsideFeatures.includes('hot tub')) {
        filter.push({match_phrase: {unit_amenities: 'Hot Tub'}})
      }
      if (this.getOutsideFeatures.includes('3 season porch')) {
        filter.push({match_phrase: {other_rooms: 'Three Season Porch'}})
      }
      if (this.getOutsideFeatures.includes('attached garage')) {
        filter.push({match_phrase: {garage: 'Attached Garage'}})
      }
      if (this.getOutsideFeatures.includes('pool')) {
        filter.push({exists: {field: 'pool'}})
      }
      if (this.getOutsideFeatures.includes('porch/deck')) {
        var porchDeckClause = {
          bool: {
            should: [
              {term: {unit_amenities: 'porch'}},
              {term: {other_rooms: 'porch'}},
              {term: {unit_amenities: 'deck'}},
              {term: {other_rooms: 'deck'}}
            ]
          }
        }
        filter.push(porchDeckClause)
      }
      if (this.getOutsideFeatures.includes('4 season porch')) {
        filter.push({match_phrase: {other_rooms: 'Four Season Porch'}})
      }

      // Heating/Cooling
      if (this.getHeatingCooling.length > 0) {
        var heatingCoolingClause = {
          bool: {
            should: [
              {terms: {heating: this.getHeatingCooling}},
              {terms: {cooling: this.getHeatingCooling}}
            ]
          }
        }
        filter.push(heatingCoolingClause)
      }

      // Parking
      if (this.getParking.includes('garage')) {
        filter.push({range: {garage_stalls: {gte: 1}}})
      }
      if (this.getLotView.includes('street')) {
        filter.push({term: {garage: 'street'}})
      }
      if (this.getLotView.includes('assigned')) {
        filter.push({match_phrase: {garage: 'Assigned'}})
      }

      // Home Age
      let minHomeAge = null
      let maxHomeAge = null
      if (this.getMinHomeAge > 0) {
        minHomeAge = parseInt(this.getMinHomeAge.match(/\d+/g).join(''))
      }
      if (this.getMaxHomeAge) {
        maxHomeAge = parseInt(this.getMaxHomeAge.match(/\d+/g).join(''))
      }
      if (minHomeAge || maxHomeAge) {
        filter.push({script: {script: {id: 'house-age-range-query', params: {year: new Date().getFullYear(), low_range: minHomeAge, high_range: maxHomeAge}}}})
      }

      // Garage
      if (['1', '2', '3'].includes(this.getGarage)) {
        filter.push({range: {garage_stalls: {gte: this.getGarage}}})
      }

      // Lot/View
      if (this.getLotView.includes('waterfront')) {
        filter.push({exists: {field: 'waterfront_view'}})
      }
      if (this.getLotView.includes('cul-de-sac')) {
        filter.push({match_phrase: {frontage: 'Cul De Sac'}})
      }
      if (this.getLotView.includes('golf course')) {
        filter.push({term: {lot_features: 'golf'}})
      }
      if (this.getLotView.includes('corner lot')) {
        filter.push({match_phrase: {lot_features: 'Corner Lot'}})
      }
      if (this.getLotView.includes('hill/mtn')) {
        filter.push({term: {topography: 'hilly'}})
      }
      if (this.getLotView.includes('ocean')) {
        filter.push({term: {waterfront_view: 'ocean'}})
      }
      if (this.getLotView.includes('lake')) {
        filter.push({term: {waterfront_view: 'lake'}})
      }
      if (this.getLotView.includes('river')) {
        filter.push({term: {waterfront_view: 'river'}})
      }

      // Community Amenities
      if (this.getCommunityAmenities.includes('pools')) {
        filter.push({term: {pool: 'shared'}})
      }
      if (this.getCommunityAmenities.includes('senior community')) {
        filter.push({term: {restrictions: 'senior'}})
      }
      if (this.getCommunityAmenities.includes('boat facilities')) {
        var boatFacilitiesClause = {
          bool: {
            should: [
              {match_phrase: {unit_amenities: 'Boat Slip'}},
              {term: {unit_amenities: 'dock'}},
              {term: {shared_amenities: 'dock'}},
              {match_phrase: {outbuildings: 'Boat House'}}
            ]
          }
        }
        filter.push(boatFacilitiesClause)
      }
      if (this.getCommunityAmenities.includes('hoa')) {
        filter.push({exists: {field: 'hoa_company_name'}})
      }
      if (this.getCommunityAmenities.includes('hot tub')) {
        filter.push({match_phrase: {shared_amenities: 'Hot Tub'}})
      }
      if (this.getCommunityAmenities.includes('gym')) {
        var gymClause = {
          bool: {
            should: [
              {match_phrase: {unit_amenities: 'Exercise Room'}},
              {match_phrase: {shared_amenities: 'Exercise Room'}}
            ]
          }
        }
        filter.push(gymClause)
      }
      if (this.getCommunityAmenities.includes('golf course')) {
        filter.push({term: {lot_features: 'golf'}})
      }
      if (this.getCommunityAmenities.includes('tennis courts')) {
        var tennisClause = {
          bool: {
            should: [
              {match_phrase: {unit_amenities: 'Tennis Courts'}},
              {match_phrase: {shared_amenities: 'Tennis Courts'}}
            ]
          }
        }
        filter.push(tennisClause)
      }

      // HOA
      if (this.getMinHOA > 0 && this.getMaxHOA > 0) {
        filter.push({range: {hoa_fee: {gte: this.getMinHOA, lte: this.getMaxHOA}}})
      } else if (this.getMinHOA > 0 && this.getMaxHOA <= 0) {
        filter.push({range: {hoa_fee: {gte: this.getMinHOA}}})
      } else if (this.getMinHOA <= 0 && this.getMaxHOA > 0) {
        filter.push({range: {hoa_fee: {lte: this.getMaxHOA}}})
      }

      return filter
    },
    async performSuggestionSearch (suggestion) {
      this.suggestion = suggestion
      if ('unit_number' in suggestion) {
        let address = ''
        if ('street_name' in suggestion) { address += suggestion['street_name'] }
        if ('city' in suggestion) { address += ' ' + suggestion['city'] }
        this.searchString = address
      } else if ('zip_code' in suggestion) {
        this.searchString = suggestion.zip_code
      } else {
        this.searchString = suggestion.city
      }
      this.changeURL()
    },
    async performSearch () {
      if (!this.getSecretAccessKey || !this.getAccessKeyId) return
      AWS.config.update({
        credentials: new AWS.Credentials(this.getAccessKeyId, this.getSecretAccessKey, this.getSessionToken),
        region: window.CONFIG.Region
      })
      try {
        var client = new elasticsearch.Client({
          connectionClass: AWSConnector,
          host: window.CONFIG.SearchDomain,
          apiVersion: '6.4'
        })
        const filter = this.buildFilter()
        let suggestion = this.suggestion
        let query
        if (suggestion && 'street_name' in suggestion) {
          // Address Search
          let conditions = []
          if (suggestion.street_number) { conditions.push({match: {street_number: {query: suggestion.street_number, boost: 2}}}) }
          if (suggestion.street_name) { conditions.push({match: {street_name: {query: suggestion.street_name, boost: 5}}}) }
          if (suggestion.street_suffix) { conditions.push({match: {street_suffix: suggestion.street_suffix}}) }
          if (suggestion.street_dir) { conditions.push({match: {street_dir: suggestion.street_dir}}) }
          if (suggestion.city) { conditions.push({match_phrase: {city: {query: suggestion.city, boost: 5}}}) }
          if (suggestion.state) { conditions.push({match: {state: suggestion.state}}) }
          if (suggestion.zip_code) { conditions.push({match: {zip_code: {query: suggestion.zip_code, boost: 5}}}) }
          query = {
            bool: {
              must: conditions,
              filter: filter
            }
          }
        } else if (suggestion && 'zip_code' in suggestion) {
          // Zip Code Search
          query = {
            bool: {
              must: [
                {match: {zip_code: {query: suggestion.zip_code, boost: 5}}},
                {match: {state: suggestion.state}}
              ],
              filter: filter
            }
          }
        } else if (suggestion && 'neighborhood' in suggestion) {
          // Neighborhood Search
          query = {
            bool: {
              must: [
                {match_phrase: {neighborhood: {query: suggestion.neighborhood, boost: 5}}},
                {match_phrase: {city: {query: suggestion.city, boost: 2}}},
                {match: {state: suggestion.state}}
              ],
              filter: filter
            }
          }
        } else if (suggestion) {
          // City Search
          query = {
            bool: {
              must: [
                {match_phrase: {city: {query: suggestion.city, boost: 5}}},
                {match: {state: suggestion.state}}
              ],
              filter: filter
            }
          }
        } else {
          // Default Text Search
          query = {
            bool: {
              must: {
                bool: {
                  should: [
                    {match: {city: {query: this.searchString, boost: 3, fuzziness: 2}}},
                    {match: {county: {query: this.searchString, fuzziness: 2}}},
                    {match: {street_name: {query: this.searchString, fuzziness: 2}}},
                    {match: {zip_code: this.searchString}},
                    {match: {state: this.searchString}}
                  ]
                }
              },
              filter: filter
            }
          }
        }
        const results = await client.search({
          index: 'house',
          type: '_doc',
          body: {
            _source: ['unit_number', 'street_number', 'street_name', 'street_suffix', 'street_dir', 'neighborhood', 'city', 'state', 'zip_code', 'bathroom_count', 'bedroom_count', 'brokerage', 'download_time', 'house_sqft', 'latitude', 'longitude', 'open_houses', 'photos', 'price', 'price_history', 'special_circumstances', 'status'],
            size: 2000,
            query: query
          }
        })
        var houseData = results.hits.hits
        houseData.forEach((house) => {
          if (house._source.photos) house._source.photos.sort()
        })
        if (houseData.length > 0) {
          this.updateLastNonEmptyQuery(filter)
        }
        // Clear suggestions when search actually performed
        this.$refs.suggestionDropdown.clearSuggestions()
        this.suggestion = null
        this.$emit('gotHouseData', houseData)
      } catch (error) {
        console.log(error)
      }
    },
    async triggerSuggestions () {
      this.$refs.suggestionDropdown.triggerSuggestions(this.searchString)
    }
  },
  watch: {
    '$route': function () {
      this.getDataFromURL()
      this.performSearch()
    },
    getSecretAccessKey: function (newKey, oldKey) {
      // triggers when user accepts terms
      // also triggers when user logs in
      // does NOT trigger when user accepts terms and then logs in. which is what we want because the page would reload at that point.
      if (newKey && !oldKey) {
        this.performSearch()
      }
    }
  }
}
</script>

<style scoped>
.input-group-text {
  cursor: pointer;
}

.btn-primary {
  width: auto !important;
}
.dropdown-form >>> .dropdown-item:hover {
  background-color: rgb(254, 237, 170) !important;
}

.dropdown-form >>> .btn {
  min-width: 160px;
  background-color: white !important;
  color: rgb(79, 79, 79);
  border-style: solid !important;
  border-color: gray !important;
  border-width: 1px !important;
  border-radius: 5px !important;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  margin-right: .3rem;
  margin-left: .3rem;
}

.dropdown-form >>> .dropdown-toggle::after {
  display:none;
}

.sqft-select:hover {
  background-color: rgb(254, 237, 170);
}

.sqft-select {
  border-radius: 30px;
  cursor: pointer;
}

.price-input {
  width: 100% !important;
}

.right-dropdown-col, .left-dropdown-col {
  padding: 0;
}

.middle-dash {
  padding-right: 5px;
  padding-left: 5px;
  padding-top: .5rem;
  margin-bottom: 0;
}

.dropdown-row {
  width: 250px;
}

.terms-text {
  text-decoration: underline;
  cursor: pointer;
}

.no-margin {
  margin: 0;
}

.form-filter-search {
  margin-left: .5rem;
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.form-filter-search-button {
  margin-right: .5rem;
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.suggestion-options {
  position: absolute;
  width: 75%;
  background-color: rgba(255, 255, 255, 0.95);
  list-style-type: none;
  padding: 0;
}

.suggestion-option {
  padding-left: 1rem;
}

.suggestion-option:hover {
  background-color: rgb(254, 237, 170);
  cursor: pointer;
}

.suggestion-header {
  padding-left: 0.5rem;
  color: #6c757d;
  font-size: .875rem;
}

.suggestion-divider {
  margin: 0.5rem;
}

#suggestions-container {
  position: relative;
  width: 100%;
  margin-right: .5rem;
  margin-left: .5rem;
  display: block;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/searchBar/TheSearchBar.vue